import { Component } from '@angular/core';

import { kitsSegmentData } from '../../../segment-data/kits-segment-data';

import { BaseScorecardListComponent } from '../base/_base-scorecard-list.component';


@Component({
  moduleId: module.id,
  selector: 'kits-scorecard',
  templateUrl: 'kits-scorecard.component.html',
})
export class KitsScorecardComponent extends BaseScorecardListComponent {
  segmentTitle: string = 'Kits';
  segmentName: string = 'kits';
  pathToScorecard = this.segmentName;
  pathToScorecardTitle = 'component_part_number.value';
  segmentData: any = kitsSegmentData;
}
